import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CANONICAL_ORIGIN = "https://pomilioseguros.com.ar";

/**
 * Mantiene el <link rel="canonical"> sincronizado con la ruta actual.
 *
 * Por qué: como es una SPA, la URL cambia client-side sin reload. Google
 * y otros crawlers leen el canonical del HTML actual, así que hay que
 * actualizarlo en cada navegación para que apunte al apex + path actual
 * (sin query/hash, que diluyen ranking sobre la misma página).
 */
export function useCanonical(): void {
  const location = useLocation();

  useEffect(() => {
    const href = `${CANONICAL_ORIGIN}${location.pathname}`;
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = href;
  }, [location.pathname]);
}
